module.exports = __webpack_public_path__ + "1.5.0-unryo/img/juniper-networks.5604ab05.svg";